import React from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'antd';
import UserCard from '../card/userCard';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { H2Sidebar, ContainerItem, OffcanvasBody } from './styles';
import PDFContent from './pdfContent';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ExcelDownloadButton from '../ExcelDownloadButton';

import { ReactComponent as PDFIcon } from '../../assets/pdf-icon.svg';

interface props {
  title: any;
  show: boolean;
  handleClose: any;
  node: any;
}

const SideBar: React.FC<props> = ({ show, handleClose, node, title }) => {
  const createAnswersCards = (allAnswers: any): any => {
    return allAnswers.map((answer: any, index: number) => {
      const containerKey = `${index}container`;
      const h2Key = `${index}h2`;
      const cardKey = `${index}card`;

      return (
        <ContainerItem key={containerKey} id={containerKey}>
          <H2Sidebar key={h2Key} id={h2Key}>
            {answer.originTopic === undefined ? '' : answer.originTopic}
          </H2Sidebar>
          <UserCard key={cardKey} answer={answer}></UserCard>
        </ContainerItem>
      );
    });
  };

  const getAnswers = (innerNode: any): any => {
    if (!innerNode || Object.keys(innerNode).length === 0) return [];

    if ('answers' in innerNode) {
      return innerNode.answers;
    }

    const children = innerNode._children
      ? innerNode._children
      : innerNode.children;

    const answersList = children.flatMap((childNode: any) =>
      getAnswers(childNode),
    );

    // removing duplicate answers
    const uniqueAnswersList = Array.from(
      new Map(answersList.map((item: any) => [item.answer, item])).values(),
    );

    return uniqueAnswersList;
  };

  const currentDate = new Date().toLocaleDateString();

  const allAnswers = getAnswers(node);
  const allAnswersHTMLCards = createAnswersCards(allAnswers);

  return (
    <>
      <Offcanvas
        style={{ width: '30%' }}
        show={show}
        key="end"
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header style={{ backgroundColor: '#ff780c' }}>
          <Offcanvas.Title style={{ color: '#FFFFFF', fontSize: '1.5vw' }}>
            {node.name}
          </Offcanvas.Title>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <ExcelDownloadButton data={node} title={title} isAllData={false} />

            <PDFDownloadLink
              document={
                <PDFContent node={node} allAnswers={allAnswers} title={title} />
              }
              fileName={`${node.name} ${currentDate}.pdf`}
            >
              <Button
                style={{
                  background: 'transparent',
                  borderColor: 'transparent',
                }}
              >
                <PDFIcon style={{ width: '3dvw', height: '5dvh' }} />
              </Button>
            </PDFDownloadLink>
            <Button
              onClick={handleClose}
              style={{
                height: '4vh',
                background: 'transparent',
                borderColor: 'transparent',
              }}
            >
              <CloseRoundedIcon fontSize="large" />
            </Button>
          </div>
        </Offcanvas.Header>
        <OffcanvasBody>{allAnswersHTMLCards}</OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default SideBar;
